/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, location: NonNullable<unknown> }} Coinvestments_Dataroom_Filesaddedtolocation5Inputs */

const en_coinvestments_dataroom_filesaddedtolocation5 = /** @type {(inputs: Coinvestments_Dataroom_Filesaddedtolocation5Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files added to ${i?.location}`)
};

/**
* | output |
* | --- |
* | "{count} files added to {location}" |
*
* @param {Coinvestments_Dataroom_Filesaddedtolocation5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_filesaddedtolocation5 = /** @type {((inputs: Coinvestments_Dataroom_Filesaddedtolocation5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Filesaddedtolocation5Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_filesaddedtolocation5(inputs)
});
export { coinvestments_dataroom_filesaddedtolocation5 as "coInvestments_dataRoom_filesAddedToLocation" }